export { default } from './DenFraudesMudancaRazaoSocial';
